import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!

  return (_ctx.config.featureResendEnabled)
    ? (_openBlock(), _createBlock(_component_ElFormItem, {
        key: 0,
        class: "el-form-item--xl-margin"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("small", null, "Please check your junk folder or click resend", -1)),
          _createVNode(_component_el_button, {
            disabled: !!_ctx.resendTimeout || _ctx.resendDisabled,
            onClick: _ctx.resendEmail
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createTextVNode("Resend ")),
              (_ctx.resendTimeout)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.resendTimeout) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1,
            __: [0]
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1,
        __: [1]
      }))
    : _createCommentVNode("", true)
}